import React from "react";
import StatisticBox from "../../common/components/StatisticBox";

// Store
import { AttendanceStatistics } from "../../api";

interface AttendeeStatisticsProps {
  data: AttendanceStatistics | undefined;
}

const AttendeeStatistics = (props: AttendeeStatisticsProps) => {
  return (
    <StatisticBox
      {...{
        title: "Attendees",
        value: props.data ? props.data.total : "...",
        description: "",
      }}
    />
  );
};

export default AttendeeStatistics;
